import React from 'react';

import { Divider } from 'shared/mui/Divider/Divider';
import { LinearProgress, LinearProgressProps } from 'shared/mui/LinearProgress/LinearProgress';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { ImportFileStatuses, ImportFileStatusesValue } from 'types/embedded/bankOperation';

import { CircleStyled, WrapperStyled } from './RequestsBankOpsImportProgress.styled';

interface RequestsBankOpsImportProgressProps {
  status: ImportFileStatusesValue;
  progress?: number;
}

type StatusConfig = {
  label: string;
  color: LinearProgressProps['color'];
  title: string;
};

const statusConfig: Record<ImportFileStatusesValue, StatusConfig> = {
  [ImportFileStatuses.Created]: {
    label: 'Файл загружен',
    color: 'primary',
    title: 'Проверка файла',
  },
  [ImportFileStatuses.Validating]: {
    label: 'В процессе',
    color: 'primary',
    title: 'Проверка файла',
  },
  [ImportFileStatuses.WaitingDecision]: {
    label: 'Завершена',
    color: 'success',
    title: 'Проверка файла',
  },
  [ImportFileStatuses.Saved]: {
    label: 'Завершено',
    color: 'success',
    title: 'Создание заявок на БО',
  },
  [ImportFileStatuses.Saving]: {
    label: 'В процессе',
    color: 'primary',
    title: 'Создание заявок на БО',
  },
  [ImportFileStatuses.Rejected]: {
    label: 'Прекращена',
    color: 'error',
    title: 'Проверка файла',
  },
  [ImportFileStatuses.Fail]: {
    label: 'Прекращена',
    color: 'error',
    title: 'Создание заявок на БО',
  },
};

export const RequestsBankOpsImportProgress: React.FC<RequestsBankOpsImportProgressProps> = ({
  status,
  progress = 0,
}) => {
  const config = statusConfig[status];

  return (
    <WrapperStyled>
      <Typography variant="body2">{config.title}</Typography>
      <Divider />
      <Stack alignItems="center" direction="row" spacing={1}>
        <CircleStyled
          sx={{
            bgcolor: `${config.color}.main`,
          }}
        />
        <Typography fontSize={12} fontWeight={500} variant="body2">
          {config.label}
        </Typography>
      </Stack>
      <LinearProgress
        color={config.color as any}
        sx={{
          height: 8,
          borderRadius: 5,
        }}
        value={progress}
        variant="determinate"
      />
    </WrapperStyled>
  );
};
